module.exports = __webpack_public_path__ + "img/imagem-03-detalhada-palmeiras-03.e2b9d16f.png";